import classNames from 'classnames'

import { SymbiosisButton } from '~/components/SymbiosisButton'
import { useMediaQuery } from '~/hooks/useMediaQuery'
import {
	MAX_VESIS_WEEKS,
	MOBILE_WIDTH_BREAKPOINT,
	WEEKS_IN_MOUTH,
	WEEKS_IN_YEAR,
} from '~/lib/constants'

import styles from './SimpleMode.pcss'

interface Props {
	availableWeeks: number
	className?: string
	disabled?: boolean
	value: number
	onChange: (weeks: number) => void
}

export function SimpleMode({
	availableWeeks,
	className,
	disabled,
	value,
	onChange,
}: Props) {
	const isMobile = useMediaQuery(`(max-width: ${MOBILE_WIDTH_BREAKPOINT}px)`)

	return (
		<div className={classNames(styles.container, className)}>
			<SymbiosisButton
				className={styles.button}
				disabled={disabled || availableWeeks < WEEKS_IN_MOUTH}
				variant={value === WEEKS_IN_MOUTH ? 'black' : 'white'}
				onClick={() => {
					onChange(WEEKS_IN_MOUTH)
				}}
			>
				{!isMobile && 1} Month
			</SymbiosisButton>

			<SymbiosisButton
				className={styles.button}
				disabled={disabled || availableWeeks < 6 * WEEKS_IN_MOUTH}
				variant={value === 6 * WEEKS_IN_MOUTH ? 'black' : 'white'}
				onClick={() => {
					onChange(6 * WEEKS_IN_MOUTH)
				}}
			>
				{!isMobile && 6} Months
			</SymbiosisButton>
			<SymbiosisButton
				disabled={disabled || availableWeeks < WEEKS_IN_YEAR}
				className={styles.button}
				variant={value === WEEKS_IN_YEAR ? 'black' : 'white'}
				onClick={() => {
					onChange(WEEKS_IN_YEAR)
				}}
			>
				{!isMobile && 1} Year
			</SymbiosisButton>
			<SymbiosisButton
				className={styles.button}
				disabled={disabled || availableWeeks !== MAX_VESIS_WEEKS}
				variant={value === MAX_VESIS_WEEKS ? 'black' : 'white'}
				onClick={() => {
					onChange(MAX_VESIS_WEEKS)
				}}
			>
				{isMobile ? '4 Y’s' : '4 Years'}
			</SymbiosisButton>
		</div>
	)
}
